/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CaseStatus {
  NEW = 'new',
  INV_ASSIGNED = 'inv_assigned',
  INV_IN_REVIEW = 'inv_in_review',
  ENF_ATTORNEY_REVIEW = 'enf_attorney_review',
  ENF_AFO_LTR_MAILED = 'enf_afo_ltr_mailed',
  ENF_HEARING = 'enf_hearing',
  ENF_FO_LTR_MAILED = 'enf_fo_ltr_mailed',
  ENF_NODD_LTR_MAILED = 'enf_nodd_ltr_mailed',
  ENF_MOTION_FOR_REHEARING = 'enf_motion_for_rehearing',
  ENF_COLLECTIONS = 'enf_collections',
  ENF_FIRST_DEMAND_LTR_MAILED = 'enf_first_demand_ltr_mailed',
  ENF_FINAL_DEMAND_LTR_MAILED = 'enf_final_demand_ltr_mailed',
  ENF_RESPONSE_RECEIVED = 'enf_response_received',
  AV_NOI_NOTICE_OF_INTENT_MAILED = 'av_noi_notice_of_intent_mailed',
  AV_FD_FINAL_DETERMINATION_LTR_MAILED = 'av_fd_final_determination_ltr_mailed',
  CLOSED_AFTER_FINAL_ORDER = 'closed_after_final_order',
  CLOSED_AFTER_HEARING_AND_FINAL_ORDER = 'closed_after_hearing_and_final_order',
  CLOSED_AGREED_ORDER = 'closed_agreed_order',
  CLOSED_CURED = 'closed_cured',
  CCMPT_COMPTROLLER_REFERRAL = 'ccmpt_comptroller_referral',
  CCMPTAG_COMPTROLLER_AG_REFERRAL = 'ccmptag_comptroller_ag_referral',
  CLOSED_DISMISSED = 'closed_dismissed',
  CLOSED_DUPLICATE_COMPLAINT = 'closed_duplicate_complaint',
  CLOSED_INSUFFICIENT_EVIDENCE = 'closed_insufficient_evidence',
  CLOSED_MEDIATED = 'closed_mediated',
  CLOSED_NO_VIOLATION = 'closed_no_violation',
  CLOSED_NO_JURISDICTION = 'closed_no_jurisdiction',
  CLOSED_OUT_OF_BUSINESS = 'closed_out_of_business',
  CLOSED_PAID_AFTER_NODD = 'closed_paid_after_nodd',
  CLOSED_REFERRAL_SENT = 'closed_referral_sent',
  CLOSED_UNCOLLECTABLE = 'closed_uncollectable',
  CLOSED_VOLUNTARY_SURRENDERED = 'closed_voluntary_surrendered',
  CLOSED_WARNING = 'closed_warning',
}
